import React from 'react';
import styled from 'styled-components';
import { BadgeProps, Checkbox } from 'components';
import {
  AVAILABLE_APPOINTMENT_STATUSES,
  AppointmentStatus,
} from '@bb/domain/dist/types';
import { useReadCalendarHover } from '../../ShowingsCalendarHoverContext';
import DotEntry from './DotEntry';
import { TIME_CHANGE_STATUSES } from '../../constants';
import { useShowingsCalendarContext } from '../../ShowingsCalendarContext';

const DotOrCheckbox: React.FC<
  Omit<BadgeProps, 'status'> & {
    dotVisible?: boolean;
    appointmentId?: string;
    isMobile?: boolean;
    status?: AppointmentStatus;
    passed?: boolean;
  }
> = ({ appointmentId, isMobile, dotVisible, status, passed }) => {
  const { hoveredAppointment } = useReadCalendarHover();
  const { selectedAppointments, setSelectedAppointments } =
    useShowingsCalendarContext();

  const showCheckbox =
    (hoveredAppointment === appointmentId ||
      selectedAppointments.includes(appointmentId)) &&
    status &&
    [...AVAILABLE_APPOINTMENT_STATUSES, ...TIME_CHANGE_STATUSES].includes(
      status,
    ) &&
    !passed;

  return (
    <DotOrCheckboxContainer>
      {showCheckbox ? (
        <Checkbox
          checked={selectedAppointments.includes(appointmentId)}
          onClick={e => e.stopPropagation()}
          onChange={e => {
            if (e.target.checked) {
              setSelectedAppointments([...selectedAppointments, appointmentId]);
            } else {
              setSelectedAppointments(prev =>
                prev.filter(_id => _id !== appointmentId),
              );
            }
          }}
        />
      ) : (
        dotVisible && (
          <DotEntry visible={dotVisible && !isMobile} offset={[0, 4]} />
        )
      )}
    </DotOrCheckboxContainer>
  );
};

const DotOrCheckboxContainer = styled.div`
  display: flex;
  position: relative;
  left: -6px;
  padding: 0;
  width: 12px;
`;

export default DotOrCheckbox;
